import { Tabs } from "antd";
import React, { useState } from "react";
import SupplierLedger from "./SupplierLedger";
import SupplierBalanceSummary from "./SupplierBalanceSummary";

export default function MainSupplierLedger() {
  const [tabChange, setTabChange] = useState(null);

  const handleTabChange = (value) => {
    setTabChange(value);
  };
  const items = [
    {
      key: "Supplier Ledger/Transaction",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Supplier Ledger/Transaction
        </div>
      ),
      children: <SupplierLedger tabChange={tabChange} />,
    },
    {
      key: "Supplier Balance Summary",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Supplier Balance Summary
        </div>
      ),
      children: <SupplierBalanceSummary tabChange={tabChange} />,
    },
  ];
  return (
    <>
      <div className="shadow-sm rounded">
        <Tabs
          onChange={handleTabChange}
          className="px-4 mt-4 custom-tabs"
          defaultActiveKey="Purchase Order List"
          items={items}
        />
      </div>
    </>
  );
}
